import {
  ModelRuleView,
  TroopProfilView,
} from '@Selectors/builder/myArmyList/make/unit/show/view/ArmyListUnitProfilV2View';
import { UnitCaracView } from '@Selectors/builder/myArmyList/make/unit/show/view/UnitCaracView';

export class UnitView {
  id: number;
  name: string;
  organisationIds: Array<number>;
  carac: UnitCaracView;
  troops: Array<TroopProfilView>;
  modelRuleUnitTroops: Array<ModelRuleView>;
  isV1: boolean;
  isV2: boolean;

  constructor(params: UnitViewParams) {
    this.id = params.id;
    this.name = params.name;
    this.organisationIds = params.organisationIds;
    this.carac = params.carac;
    this.troops = params.troops;
    this.modelRuleUnitTroops = params.modelRuleUnitTroops;
    this.isV1 = params.isV1;
    this.isV2 = params.isV2;
  }
}

export type UnitViewParams = {
  id: number;
  name: string;
  organisationIds: Array<number>;
  carac: UnitCaracView;
  troops: Array<TroopProfilView>;
  modelRuleUnitTroops: Array<ModelRuleView>;
  isV1: boolean;
  isV2: boolean;
};
